import { render } from "./ModalInstruccionesBot.vue?vue&type=template&id=f2991d66&scoped=true"
import script from "./ModalInstruccionesBot.vue?vue&type=script&lang=js"
export * from "./ModalInstruccionesBot.vue?vue&type=script&lang=js"

import "./ModalInstruccionesBot.vue?vue&type=style&index=0&id=f2991d66&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2991d66"]])

export default __exports__